import actiontypes from '../actiontypes'


const initialState = {
    institution_list: [],
    active: '',
    categories: [],
    districts: [],
    loading_categories: false,
    loading_districts: false,
    fetching_institutions: false,
    saving_institution: false,
    save_institution_failed: false,
    save_institution_errors: {},

    fetching_institution: false,
    fetch_institution_failed: false,
    institution_detail: {}
}

const institutionReducer = (state=initialState, action) => {
    switch (action.type) {
        case actiontypes.FETCHING_INSTITUTION: {
            return {
                ...state,
                fetching_institution: true,
                fetch_institution_failed: false,
                institution_detail: {}
            }
        }
        case actiontypes.FETCHED_INSTITUTION: {
            return {
                ...state,
                fetching_institution: false,
                institution_detail: action.payload
            }
        }
        case actiontypes.FETCH_INSTITUTION_FAILED: {
            return {
                ...state,
                fetching_institution: false,
                fetch_institution_failed: true,
                institution_detail: {}
            }
        }
        case actiontypes.CLEAR_EDIT_INSTITUTION: {
            return {
                ...state,
                institution_detail: {}
            }
        }
        case actiontypes.SAVING_INSTITUTION: {
            return {
                ...state,
                saving_institution: true,
                save_institution_failed: false,
                save_institution_errors: {}
            }
        }
        case actiontypes.SAVED_INSTITUTION: {
            const new_list =[...state.institution_list]
            const index = new_list.findIndex(item => item._key === action.payload.body._key)
            if (index >= 0) {
                new_list[index] = action.payload.body
            }
            else {
                new_list.push(action.payload.body)
            }

            return {
                ...state,
                institution_list: new_list,
                institution_detail: action.payload.body,
                saving_institution: false,
                save_institution_failed: false,
                save_institution_errors: {}
            }
        }
        case actiontypes.SAVE_INSTITUTION_FAILED: {
            return {
                ...state,
                saving_institution: false,
                save_institution_failed: true,
                save_institution_errors: action.payload.field_errors
            }
        }
        case actiontypes.SET_FILTERS: {
            return {
                ...state,
                institution_list: []
            }
        }
        case actiontypes.SET_INSTITUTIONS:
            return {
                ...state,
                institution_list: action.payload || []
            }
        case actiontypes.CLEAR_INSTITUTIONS:
            return {
                ...state,
                active: '',
                institution_list: []
            }
        case actiontypes.SET_ACTIVE_INSTITUTION:
            return {
                ...state,
                active: action.payload
            }
        case actiontypes.LOADING_CATEGORIES:
            return {
                ...state,
                loading_categories: true
            }
        case actiontypes.LOADED_CATEGORIES:
            return {
                ...state,
                loading_categories: false,
                categories: action.payload
            }
        case actiontypes.LOADING_DISTRICTS:
            return {
                ...state,
                loading_districts: true
            }
        case actiontypes.LOADED_DISTRICTS:
            return {
                ...state,
                loading_districts: false,
                districts: action.payload
            }
        case actiontypes.FETCHING_INSTITUTIONS:
            return {
                ...state,
                fetching_institutions: true,
                institution_list: []
            }
        case actiontypes.FETCHED_INSTITUTIONS:
            return {
                ...state,
                fetching_institutions: false,
                institution_list: action.payload
            }
        default:
            return state;
    }
}

export default institutionReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers/institutions.js
 **/